import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { appPaths } from '../../app.paths';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  currentUrl = '';
  private url: BehaviorSubject<string> = new BehaviorSubject('');
  private history: string[] = [];

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);

        this.setCurrentUrl(event.url);
      }
    });
  }

  setCurrentUrl(url: string) {
    this.currentUrl = url;
    this.url.next(this.currentUrl);
  }

  getCurrentUrl() {
    return this.url.asObservable();
  }

  goBack(): void {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl(appPaths.HOME);
    }
  }
}
